import PropTypes from 'prop-types';
import React from 'react';
import JSONDisplay from './JSONDisplay.jsx';

import useMetrics from '../../../../hooks/useMetrics.js';

export default function MetricResultDisplay({metricRequests, className}) {

    const {isLoading, error, data} = useMetrics(metricRequests);

    return (
        <>

            { isLoading &&
                <h3 className={className}>Loading...</h3>
            }

            { error &&
                <h3 className={className}>Error: {error.message}</h3>
            }

            { data &&
                <JSONDisplay
                    json={data}
                    className={className}
                />
            }
        </>
    );
}


MetricResultDisplay.propTypes = {
    metricRequests: PropTypes.array
};
